// src/lib/booking-requests-helpers.js — Phase 5.4 Commit 7
//
// Helpers logique pure pour BookingRequestsView (testable Jest sans React).

export const STATUT_COLORS = {
  pending:      { bg: '#fff3cd', fg: '#856404', label: '⏳ En attente' },
  validated:    { bg: '#d4edda', fg: '#155724', label: '✅ Validé' },
  rejected:     { bg: '#f8d7da', fg: '#721c24', label: '❌ Rejeté' },
  expired:      { bg: '#e2e3e5', fg: '#6c757d', label: '⏰ Expiré' },
  paid_caution: { bg: '#cce5ff', fg: '#004085', label: '💳 Caution payée' },
  paid_stay:    { bg: '#cce5ff', fg: '#004085', label: '💰 Séjour payé' },
  confirmed:    { bg: '#d4edda', fg: '#155724', label: '✅ Confirmé' },
  cancelled:    { bg: '#e2e3e5', fg: '#6c757d', label: '🚫 Annulé' },
}

/**
 * Lookup nom logement dans cfg.props[].logs[] + chambres sous-loc.
 * Aligné helper findLogementInCfg (ADR-051 dédup byId).
 *
 * @param {object|null} cfg
 * @param {string|null} logementId
 * @returns {string} nom logement ou logementId fallback
 */
export function findLogementNom(cfg, logementId) {
  if (!cfg?.props || !logementId) return logementId
  for (const prop of cfg.props) {
    for (const log of prop.logs || []) {
      if (log.id === logementId) return log.nom || logementId
      for (const ch of log.chambres || []) {
        if (ch.id === logementId) return ch.nom || logementId
      }
    }
  }
  return logementId
}
